module.exports = __webpack_public_path__ + "img/3min_scan.536a7ad7.png";